<template>
  <div
    :is="multiple ? 'VDraggable' : 'div'"
    v-if="inputVal"
    v-model="inputVal"
    v-bind="this.multiple ? dragOptions : {}"
    class="thumbnail-list"
  >
    <transition-group type="transition" name="flip-list" tag="span">
      <ThumbnailPreviewItem
        v-for="image in list"
        :key="image"
        :imageSrc="
          image | imagePath(uploadType, image.includes('.pdf') ? 'original' : 'default', true, t)
        "
        @edit="$emit('edit', image)"
        @remove-click="$emit('remove-click', image)"
        @download="$emit('download', image)"
        :read-only="readOnly"
        :uploadType="uploadType"
        :role="role"
        :dropzoneTitle="dropzoneTitle"
        :style="style"
      ></ThumbnailPreviewItem>
    </transition-group>
  </div>
</template>

<script>
import vModelMixin from '@/mixins/v-model';
import imagePath from '@/filters/image-path';
import ThumbnailPreviewItem from '@/components/thumbnail/ThumbnailPreviewItem.vue';
import VDraggable from 'vuedraggable';

export default {
  mixins: [vModelMixin],
  components: {
    ThumbnailPreviewItem,
    VDraggable,
  },
  props: {
    uploadType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
    t: {
      type: Number,
    },
    role: {
      type: String,
    },
    dropzoneTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    list() {
      return this.multiple ? this.inputVal : [this.inputVal];
    },
    dragOptions() {
      return {
        animation: 360,
        disabled: this.readOnly,
        ghostClass: 'ghost',
      };
    },
    style() {
      return { cursor: this.readOnly || !this.multiple ? 'auto' : 'grab' };
    },
  },
  filters: {
    imagePath,
  },
};
</script>

<style lang="scss" scoped>
.thumbnail-list {
  span {
    display: flex;
    flex-wrap: wrap;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.ghost {
  opacity: 0.5;
  background: #b1d7fb;
}
</style>
